import { ff } from '@atlassian/jira-feature-flagging';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import JWMBoardComponentNew from './board';
import JWMBoardComponentOld from './board-old';

export { default as JWMBoardHeader } from './header';

const JWMBoardComponent = componentWithCondition(
	() => ff('jwm.board-awesome-enhancements'),
	JWMBoardComponentNew,
	JWMBoardComponentOld,
);

export default JWMBoardComponent;
